$(document).ready(function(){
	$( '.store-popup-open' ).click(function ( event ) {
		start_lazy_map( $( $( event.currentTarget ).data( 'target' ) ) )
	});

	function start_lazy_map( map_element ) {
		const data_src = map_element.data( 'src' );
		if ( data_src ) {
			map_element.removeData( 'src' );
			map_element.attr( 'src', data_src );
		}
	}
});